<template>
  <v-dialog v-model="dialog" width="1200px">
    <v-card>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" text @click="close"> Fechar </v-btn>
      </v-card-actions>
      <v-card-title>
        <span class="headline">Importar</span>
      </v-card-title>

      <v-card-text>
        <v-row>
          <v-file-input
            accept="*"
            label="File input"
            v-model="file"
          ></v-file-input>

          <v-btn class="primary" @click="importFile(file)">Load </v-btn>
            <v-btn class="primary" @click="saveImport">Importar</v-btn>
        </v-row>
      </v-card-text>

      <v-card-text>
        <v-simple-table>
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">Nome</th>
                <th class="text-right">Email</th>
                <th class="text-right">CEP</th>
                <th class="text-right">Rua</th>
                <th class="text-right">Bairro</th>
                <th class="text-right">Número</th>
                <th class="text-right">Complemento</th>
                <th class="text-right">Cidade</th>
                <th class="text-right">Telefone</th>
                <th class="text-right">Celular</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in objectsImport" v-bind:key="item.id">
                <td>{{ item.cliente.nome }}</td>
                <td>{{ item.cliente.email }}</td>
                <td>{{ item.cliente.cep }}</td>
                <td>{{ item.cliente.rua }}</td>
                <td>{{ item.cliente.bairro }}</td>
                <td>{{ item.cliente.numero }}</td>
                <td>{{ item.cliente.complemento }}</td>
                <td>{{ item.cliente.cidade }}</td>
                <td>{{ item.cliente.telefone }}</td>
                <td>{{ item.cliente.celular }}</td>

                <td class="text-right"></td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-card-text>
      <v-card-text>
        <v-row>
          <v-spacer></v-spacer>
          <v-btn class="primary" @click="saveImport">Importar</v-btn>
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import Contact from "../../../../libraries/classes/Contact";
import hebelApi from "../../../../libraries/hebel/hebelApi";

export default {
  components: {},
  name: "modal-import-contacts",
  props: ["dialog"],
  data() {
    return {
      objectsImport: [],
      file: null,
      contacts:[],
    };
  },

  watch: {},
  computed: {},
  created() {},
  async mounted() {
      this.contacts = await hebelApi.contacts.getAll();

  },

  methods: {
    close() {
      this.$emit("close");
    },
    async saveImport() {
      //  alert("save import")
      var newContacts = [];
      var a =0;
      for(a= 0; a < this.objectsImport.length; a++){
        var item = this.objectsImport[a];
        var c = new Contact();
        console.log(JSON.stringify(c));
        c.name =  item.cliente.nome;
        c.email = item.cliente.email;
        c.zipCode = item.cliente.cep;
        c.streetAddress = item.cliente.rua;
        c.neighborhood = item.cliente.bairro;
        c.streetAddressNumber = item.cliente.numero;
        c.streetAddressLine2 = item.cliente.complemento;
        c.cityName = item.cliente.cidade;
        c.phone = item.cliente.telefone;
        c.phone = item.cliente.celular;
        newContacts.push(c);
      };

      var filteredContacts = [];
      for(a = 0; a < newContacts.length; a++ ){
          var item = newContacts[a];
          console.log(JSON.stringify(item))
          console.log(JSON.stringify(a));

          var foundItem = filteredContacts.find(value => ((value.name == item.name)||( (value.email !="")&& (value.email == item.email) ) ) )
          var foundItem2 = this.contacts.find(value => ((value.name == item.name)||( (value.email !="") && (value.email == item.email)  ) ) )
          //alert(JSON.stringify(foundItem2))
          if((foundItem || foundItem2)){
             //alert(JSON.stringify(foundItem));
          }else{
            filteredContacts.push(item);
          }
      };
      console.log(JSON.stringify(filteredContacts));
      for (a = 0 ; a < filteredContacts.length ;a++){
        console.log(JSON.stringify(a));
        var addContact = filteredContacts[a];
        console.log(JSON.stringify(addContact));
        console.log("Will add contact")
        var ans = await hebelApi.contacts.upsert(addContact);
      }
      console.log("Finish")

    },


    async importFile(file) {
      if (file) {
        var json = await this.$globalFunctions.readFileAsync(file);
        console.log(json);
        this.objectsImport = JSON.parse(json);
        //alert(JSON.stringify(this.objectsImport))
        this.$forceUpdate();
      }
    },
  },
};
</script>


<style scoped>
</style>